'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _webfontloader = require('webfontloader');

var WebFont = _interopRequireWildcard(_webfontloader);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _keyCode = require('appkit-react-utils/keyCode');

var _keyCode2 = _interopRequireDefault(_keyCode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var babelPluginFlowReactPropTypes_proptype_CommonType = require('appkit-react-utils/commonType').babelPluginFlowReactPropTypes_proptype_CommonType || require('prop-types').any;

var INIT_LOAD_CLASS = 'a-init-load';
var DATA_VALUE = 'data-value';

var ButtonGroup = function (_React$Component) {
  _inherits(ButtonGroup, _React$Component);

  function ButtonGroup(props) {
    _classCallCheck(this, ButtonGroup);

    // isControlled true means it is controlled by user prop
    // isControlled false means it is controlled by component state
    var _this = _possibleConstructorReturn(this, (ButtonGroup.__proto__ || Object.getPrototypeOf(ButtonGroup)).call(this, props));

    _this.isControlled = props.value != null;
    _this.state = {
      indicatorStyle: {
        width: 0,
        left: 0
      }
    };
    _this.valueToIndex = {};
    if (!_this.isControlled) {
      _this.state.groupValue = props.defaultValue || '';
    }
    var o = _this;
    WebFont.load({
      custom: {
        families: ['PwC Helvetica Neue', 'PwC Helvetica Neue:n2,n3,n4,n5,n7,n9']
      },
      active: function active() {
        o.calcIndicatorStyle();
      }
    });
    return _this;
  }

  _createClass(ButtonGroup, [{
    key: 'onChange',
    value: function onChange(evt, value) {
      var onChange = this.props.onChange;

      this.setState({
        groupValue: value
      });
      onChange && onChange(evt, value);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getValueToIndex();
      this.timeout = setTimeout(this.calcIndicatorStyle.bind(this));
      this.correctInitCheckedItemStyle();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      var self = this;
      setTimeout(function () {
        self.calcIndicatorStyle();
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // case 1: isControlled false, use this.state.groupValue !== prevState.groupValue condition
      // case 2: isControlled true, use this.props.value !== prevProps.value condition
      if (this.isControlled && this.props.value !== prevProps.value || !this.isControlled && this.state.groupValue !== prevState.groupValue) {
        this.clearInitCheckedItemStyle();
        this.calcIndicatorStyle();
      }
    }
  }, {
    key: 'correctInitCheckedItemStyle',
    value: function correctInitCheckedItemStyle() {
      if (!this.radioGroupRef) return;
      var btnGroup = this.radioGroupRef;
      btnGroup.className += ' ' + INIT_LOAD_CLASS;
    }
  }, {
    key: 'clearInitCheckedItemStyle',
    value: function clearInitCheckedItemStyle() {
      if (!this.radioGroupRef) return;
      var btnGroup = this.radioGroupRef;

      // clear .a-init-load class
      if (btnGroup.className.indexOf(INIT_LOAD_CLASS) >= 0) {
        btnGroup.className = btnGroup.className.replace(' ' + INIT_LOAD_CLASS, '');
      }
    }
  }, {
    key: 'getValueToIndex',
    value: function getValueToIndex() {
      if (!this.radioGroupRef) return;
      var groupItems = this.radioGroupRef.querySelectorAll('.a-btn-group .a-btn');

      for (var i = 0, len = groupItems.length; i < len; i++) {
        var button = groupItems[i];
        var dataValue = button.getAttribute(DATA_VALUE);
        this.valueToIndex[dataValue] = i;
      }
    }
  }, {
    key: 'calcIndicatorStyle',
    value: function calcIndicatorStyle() {
      if (!this.radioGroupRef) return;
      var btnGroup = this.radioGroupRef;
      if (!btnGroup) return;

      var groupItems = btnGroup.querySelectorAll('.a-btn-group .a-btn');
      var currIdx = this.isControlled ? this.valueToIndex[this.props.value] : this.valueToIndex[this.state.groupValue];
      if (currIdx == null) return;
      var currBtnItem = groupItems[currIdx];
      // do not calculate indicator style if defaultValue and disabled used together.
      // see: https://trello.com/c/G7vHF643/313-buttonthe-hover-effect-is-incorrect-when-combine-defaultvalue-and-disabled-for-button-group
      if (currBtnItem.classList.contains('disabled')) return;
      var currBtnItemBox = currBtnItem.getBoundingClientRect();
      var btnGroupBox = btnGroup.getBoundingClientRect();
      var indicatorStyle = {
        left: currBtnItemBox.left - btnGroupBox.left,
        width: currBtnItemBox.width
      };

      if (currIdx === 0) {
        indicatorStyle.borderRadius = '0.125rem 0 0 0.125rem';
      } else if (currIdx === groupItems.length - 1) {
        indicatorStyle.borderRadius = '0 0.125rem 0.125rem 0';
      }

      this.setState({
        indicatorStyle: indicatorStyle
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          _props$kind = _props.kind,
          kind = _props$kind === undefined ? 'primary' : _props$kind,
          _props$size = _props.size,
          size = _props$size === undefined ? 'sm' : _props$size,
          onChange = _props.onChange,
          className = _props.className,
          style = _props.style,
          children = _props.children,
          otherProps = _objectWithoutProperties(_props, ['kind', 'size', 'onChange', 'className', 'style', 'children']);

      var indicatorStyle = this.state.indicatorStyle;

      var btnGroupPrefixCls = 'a-btn-group';
      var classes = (0, _classnames3.default)(btnGroupPrefixCls, className);
      var indicatorClasses = (0, _classnames3.default)('a-indicator', _defineProperty({}, 'a-' + kind, true));

      return _react2.default.createElement(
        'div',
        Object.assign({
          ref: function ref(el) {
            return _this2.radioGroupRef = el;
          }
          //onChange={this.onChange.bind(this)}
          , className: classes,
          style: style,
          onMouseDown: function onMouseDown(e) {
            var value = e.target.getAttribute(DATA_VALUE);
            _this2.onChange(e, value);
          },
          onKeyDown: function onKeyDown(e) {
            if (e.keyCode === _keyCode2.default.ENTER) {
              var value = e.target.getAttribute(DATA_VALUE);
              _this2.onChange(e, value);
            }
          }
        }, otherProps),
        _react2.default.createElement('div', { className: indicatorClasses, style: indicatorStyle }),
        _react2.default.Children.map(children, function (child) {
          if (!_react2.default.isValidElement(child)) {
            return null;
          }

          var isActive = _this2.isControlled ? _this2.props.value === child.props[DATA_VALUE] : _this2.state.groupValue === child.props[DATA_VALUE];

          var _child$props = child.props,
              className = _child$props.className,
              style = _child$props.style,
              childOthers = _objectWithoutProperties(_child$props, ['className', 'style']);

          return _react2.default.cloneElement(child, _extends({
            size: size,
            kind: kind,
            negative: kind === 'negative',
            gray: kind === 'gray',
            className: (0, _classnames3.default)(className, {
              'a-btn-selected': isActive
            }),
            style: style
          }, childOthers));
        })
      );
    }
  }]);

  return ButtonGroup;
}(_react2.default.Component);

ButtonGroup.propTypes = {
  size: _propTypes2.default.oneOf(['sm', 'md', 'lg', 'xl']),
  kind: _propTypes2.default.oneOf(['primary', 'negative', 'gray']),
  value: _propTypes2.default.string,
  defaultValue: _propTypes2.default.string,
  onChange: _propTypes2.default.func
};

exports.default = ButtonGroup;